import { authGuard } from '../middleware/auth'

export const setupRouterGuards = (
  to: any,
  from: any,
  next: any
) => {
  // Устанавливаем заголовок страницы
  if (to.meta.title) {
    document.title = `${to.meta.title}`
  }

  // Проверяем авторизацию
  const authResult = authGuard(to)

  if (authResult instanceof Promise) {
    authResult.then(result => {
      if (result === true) {
        next()
      } else {
        next(result)
      }
    })
  } else if (authResult === true) {
    next()
  } else {
    next(authResult)
  }
}
